var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFullGreen = function SvgStarFullGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.517,
    height: 15.517
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Star 1",
    d: "m7.757 0 2.493 4.969 5.265.958-3.723 4.029.761 5.561-4.796-2.479-4.794 2.479.761-5.561L0 5.927l5.265-.958Z"
  })));
};
export default SvgStarFullGreen;